import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import { I18nextProvider } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import genericStyles from './GenericComponents/GenericStyles.module.css';
import styles from './App.module.css';
import { CCProvider, useCCContext } from './CC/CCContext';
import './CC/CC';
import Startup from './Startup';
import User from './User/User';
import Mobile from './Mobile/Mobile';
import Header from './Header/Header';
import HeaderMobile from './Header/HeaderMobile';
import Footer from './Footer/Footer';
import SimpleSearchBox from './Search/SimpleSearchBox';
import Filter from './Filter/Filter';
import Facet from './Facet/Facet';
import BasketFacet from './Facet/BasketFacet';
import HierarchicalFacet from './Facet/HierarchicalFacet';
import Navigator from './Navigator/Navigator';
import ViewMode from './Navigator/ViewMode';
import BrowseMode from './Navigator/BrowseMode';
import ResultSet from './Result/ResultSet';
import Map from './Record/Map';
import QuerySummary from './Result/QuerySummary';
import Sort from './Navigator/Sort';
import EmbedCount from './Embed/EmbedCount';
import EmbedFacet from './Embed/EmbedFacet';
import EmbedArticle from './Embed/EmbedArticle';
import DebugCC from './Diagnostics/DebugCC';
import RightClickPopup from './GenericComponents/RightClickPopup';
import HomepageBlock from './HomePageblock';
import GenericIconButton from './GenericComponents/GenericIconButton';
import AlbumViewer from './AlbumEditor/AlbumViewer';
import AnnotatedImageViewer from './AlbumEditor/AnnotatedImageViewer';
import { ccConfig, CC, Search } from './CC/CC';
import * as ccUtils from './CC/utils';

import { EditorContent, useEditor } from '@tiptap/react';

function MainContent() {
  const { t } = useTranslation();
  const { user, cc, setCc, first, setFirst, recordsPerPage, setRecordsPerPage, viewMode, setViewMode, browseMode, setBrowseMode, data, setData, isReady } = useCCContext();
  const ctx = useCCContext();
  const [dropdownOpen, setDropdownOpen] = useState(false); // Plaats de useState hier
  const [debugOpen, setDebugOpen] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [introTextEnglish, setIntroTextEnglish] = useState<string>('');
  const [introTextFrench, setIntroTextFrench] = useState<string>('');
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  //const monumentName = 'Hôtel de la Marine'; // Example monument name

  //embed stuff
  const location = useLocation();
  useEffect(() => {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('config', 'G-VWZN8QDQRC', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);

  const params = new URLSearchParams(location.search);
  const embedType = params.get('embed');
  const facetValue = params.get('facet');
  const articleId = params.get('articleId');
  const state = params.get('state');

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  const queryParams = new URLSearchParams(window.location.search);
  //const isTabletOrMobile = queryParams.get('tablet') === 'true' || queryParams.get('mobile') === 'true';
  const isTabletOrMobile = window.innerWidth < 1080 || queryParams.get('tablet') === 'true' || queryParams.get('mobile') === 'true';

  const showAlbumExternal = queryParams.get('albumexternal');
  const showAlbumEmbed = queryParams.get('albumembed');

  const getMonumentParam = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('monument') || 'no monument specified';
  };

  const handleDebugOpen = () => {
    setDebugOpen(true);
  };

  const handleDebugClose = () => {
    setDebugOpen(false);
  };

  const handleAddCustomSearch = () => {
    ccUtils.addCustomSearch(ctx, '*', 'All fields', ['masque', 'voiture'], '');
    console.log('Custom search added:', cc.customSearchCriteria);
  };

  const handleCustomSearch = () => {
    ccUtils.customSearch(ctx, '/Record/Title', 'Title', 'masque', 'Searching for Masque');
    console.log('Custom search set:', cc.customSearchCriteria);
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollToTop && window.scrollY > 1000) {
        setShowScrollToTop(true);
      } else if (showScrollToTop && window.scrollY <= 1000) {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);

    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScrollToTop]);

  if (!isReady) {
    return <div></div>;
  }

  if (embedType === 'count') {
    return <EmbedCount state={state} ccContext={ctx} />;
  }

  if (embedType === 'facet' && facetValue) {
    return <EmbedFacet facetName={facetValue} />
  }

  if (embedType === 'article' && articleId) {
    return <EmbedArticle articleId={articleId} ccContext={ctx} />
  }

  if (showAlbumExternal) {
    return <AlbumViewer initialAlbumId={showAlbumExternal} />
  }

  return (
    <I18nextProvider i18n={i18n}>
      {isTabletOrMobile ? (
        <Mobile></Mobile>
      ) : (
        <div className={styles.App}>
          <Header />
          <div className={styles.menuText}>
            <a 
              href="?albumembed=04493ee5-01a7-4bc0-b286-2ebbc4f22cb5" 
              className={styles.linkMenu}
            >
              {t("Accueil")}
            </a>

            <span className={styles.separator}>|</span>
            <a 
              href="?albumembed=7d8c7e97-e16d-469f-b347-d427c2ff91da" 
              className={styles.linkMenu}
            >
              {t("A propos")}
            </a>
            <span className={styles.separator}>|</span>

            <div className={styles.dropdown}>
              <span
                className={styles.linkMenu}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {t("Institutions")}&nbsp;&nbsp;&nbsp;&nbsp;▼
              </span>
              {dropdownOpen && (
                <div className={styles.submenu}>
                  <a href="?id=sit_11" className={styles.submenuLink}>{t("Amay - Château de Jehay")}</a>
                  <a href="?id=sit_12" className={styles.submenuLink}>{t("Andenne - Espace muséal d'Andenne")}</a>
                  <a href="?id=sit_25" className={styles.submenuLink}>{t("Arlon - Musée archéologique")}</a>
                  <a href="?id=sit_26" className={styles.submenuLink}>{t("Arlon - Musée Gaspar")}</a>
                  <a href="?id=sit_9" className={styles.submenuLink}>{t("Blegny - Blegny-Mine")}</a>
                  <a href="?id=sit_27" className={styles.submenuLink}>{t("Durbuy - Maison des Mégalithes de Wéris")}</a>
                  <a href="?id=sit_16" className={styles.submenuLink}>{t("Ferrières - Musée de Château fort de Logne")}</a>
                  <a href="?id=sit_21" className={styles.submenuLink}>{t("Flémalle - Préhistomuseum")}</a>
                  <a href="?id=sit_36" className={styles.submenuLink}>{t("Herstal - Musée de la Ville de Herstal")}</a>
                  <a href="?id=sit_29" className={styles.submenuLink}>{t("Huy - Musée communal")}</a>
                  <a href="?id=sit_8" className={styles.submenuLink}>{t("Liège - Aquarium-Muséum")}</a>
                  <a href="?id=sit_30" className={styles.submenuLink}>{t("Liège - Fonds patrimoniaux")}</a>
                  <a href="?id=sit_33" className={styles.submenuLink}>{t("Liège - Grand Curtius")}</a>
                  <a href="?id=sit_32" className={styles.submenuLink}>{t("Liège - Hôtel d'Ansembourg")}</a>
                  <a href="?id=sit_34" className={styles.submenuLink}>{t("Liège - La Boverie")}</a>
                  <a href="?id=sit_13" className={styles.submenuLink}>{t("Liège - Maison de la Métallurgie et de l'Industrie")}</a>
                  <a href="?id=sit_14" className={styles.submenuLink}>{t("Liège - Maison de la Science")}</a>
                  <a href="?id=sit_15" className={styles.submenuLink}>{t("Liège - Musée d'art contemporain en plein air du Sart Tilman")}</a>
                  <a href="?id=sit_7" className={styles.submenuLink}>{t("Liège - Musée de la Vie wallonne")}</a>
                  <a href="?id=sit_35" className={styles.submenuLink}>{t("Liège - Musée des Transports en commun de Wallonie")}</a>
                  <a href="?id=sit_37" className={styles.submenuLink}>{t("Liège - Musée du Luminaire")}</a>
                  <a href="?id=sit_38" className={styles.submenuLink}>{t("Liège - Musée Grétry")}</a>
                  <a href="?id=sit_17" className={styles.submenuLink}>{t("Liège - Musée Wittert")}</a>
                  {/* <a href="?id=sit_39" className={styles.submenuLink}>{t("Liège - Musées de la Ville de Liège")}</a> */}
                  <a href="?id=sit_19" className={styles.submenuLink}>{t("Liège - Patrimoine artistique de la Province de Liège")}</a>
                  <a href="?id=sit_20" className={styles.submenuLink}>{t("Liège - Pôle muséal & culturel de l'Université de Liège")}</a>
                  <a href="?id=sit_46" className={styles.submenuLink}>{t("Liège - Trésor de la cathédrale de Liège")}</a>
                  <a href="?id=sit_22" className={styles.submenuLink}>{t("Liège - Trinkhall museum")}</a>
                  <a href="?id=sit_41" className={styles.submenuLink}>{t("Malmedy - Malmundarium")}</a>
                  <a href="?id=sit_42" className={styles.submenuLink}>{t("Spa - Musée de la Forêt et des Eaux")}</a>
                  <a href="?id=sit_43" className={styles.submenuLink}>{t("Spa - Spa ! Museum - Musée de la Ville d'Eaux")}</a>
                  <a href="?id=sit_10" className={styles.submenuLink}>{t("Sprimont - Centre d'Interprétation de la Pierre")}</a>
                  <a href="?id=sit_44" className={styles.submenuLink}>{t("Stavelot - Trésor de Stavelot")}</a>
                  <a href="?id=sit_18" className={styles.submenuLink}>{t("Verviers - Musées de Verviers")}</a>
                  <a href="?id=sit_45" className={styles.submenuLink}>{t("Wanze - Château féodal de Moha")}</a>
                </div>
              )}
            </div>
                        
            <span className={styles.separator}>|</span>
            <a
              href={`?state=${JSON.stringify({
                Searches: [
                  { identifier: "simpleSearch", field: "All search fields" }
                ],
                matchAllCriteria: true,
                facets: { recordtype: ["Objets"] }
              })}`}
              className={styles.linkMenu}
              >
              {t("Collections")}
            </a>
            <span className={styles.separator}>|</span>
            <a
              href={`?state=${JSON.stringify({
                Searches: [
                  { identifier: "simpleSearch", field: "All search fields" }
                ],
                matchAllCriteria: true,
                facets: { recordtype: ["Exposition"] }
              })}`}
              className={styles.linkMenu}
              >
              {t("Expositions")}
            </a>
            <span className={styles.separator}>|</span>
            <a
              href={`?state=${JSON.stringify({
                Searches: [
                  { identifier: "simpleSearch", field: "All search fields" }
                ],
                matchAllCriteria: true,
                facets: { recordtype: ["Personnes et institutions"] }
              })}`}
              className={styles.linkMenu}
              >
              {t("Persons and institutions")}
            </a>
          </div>          

          <div style={{ 'display': 'none' }}>
            <div onClick={handleAddCustomSearch} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Click me to add custom search
            </div>
            <div onClick={handleCustomSearch} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Click me to set custom search
            </div>
            <div onClick={() => ccUtils.activateFilter(ctx, "objects")} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Activate Object Filter
            </div>
            <div onClick={() => ccUtils.deactivateFilter(ctx, "objects")} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Deactivate Object Filter
            </div>
            <div onClick={() => ccUtils.clearFacet(ctx, "words")} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Clear Words Facet
            </div>
            <div onClick={() => ccUtils.addFacetValue(ctx, "words", "bois")} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Add New Word to Words Facet
            </div>
            <div onClick={() => ccUtils.addFacetValue(ctx, "words", ["bois", "voiture"])} style={{ padding: '0px', margin: '0px', border: '1px solid black', cursor: 'pointer' }}>
              Add New Words to Words Facet
            </div>
            <div onClick={() => ccUtils.clearSearch(ctx)} style={{ padding: '20px', margin: '10px', border: '1px solid black', cursor: 'pointer' }}>
              Clear Search
            </div>
          </div>

          <div className={styles.debugLink} onClick={handleDebugOpen}>
            <RightClickPopup url="https://example.com/record">Debug</RightClickPopup></div>

          <div className={styles.container}>
            <div className={styles.middlePane}>
              <div className={styles.bottomMiddlePane}>
                <div className={styles.leftColumn}>
                  {/*<div className={styles.filters} style={{ display: "none" }}>*/}
                  <div className={styles.filters}>
                    <div className={styles.objetsIcono}>
                      {/* <Filter filterName="filter_objects" /> */}
                      {/* <Filter filterName="filter_icono" /> */}
                      {/* <Filter filterName="filter_freeOfRights" /> */}
                    </div>
                  </div>

                  <div className={styles.facets}>
                    <div style={{ textAlign: 'center' }}>
                      <p>{t("Filtres de recherche")}</p>
                    </div>
                  <div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['institution'] && cc.facets['institution'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_institution")}</span>
                        {cc.facets['institution'] && cc.facets['institution'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='institution' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    {true && <>
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.hierarchicalFacets['fonds'] && cc.hierarchicalFacets['fonds'].length > 0 ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_fonds")}</span>
                          {cc.hierarchicalFacets['fonds'] && cc.hierarchicalFacets['fonds'].length > 0 ?
                            <span className={styles.facetActiveDot}></span> : null}
                        </div>
                        <div className={styles.facet}>
                          <HierarchicalFacet hierarchicalFacetName='fonds' topCN='MVW.AAX' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                        </div>
                      </div>
                    </>
                    }
                    {true && <>
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.hierarchicalFacets['categorie'] && cc.hierarchicalFacets['categorie'].length > 0 ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_categorie")}</span>
                          {cc.hierarchicalFacets['categorie'] && cc.hierarchicalFacets['categorie'].length > 0 ?
                            <span className={styles.facetActiveDot}></span> : null}
                        </div>
                        <div className={styles.facet}>
                          <HierarchicalFacet hierarchicalFacetName='categorie' topCN='MVW.ABE' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                        </div>
                      </div>
                    </>
                    }
                    <div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['classification'] && cc.facets['classification'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_classification")}</span>
                        {cc.facets['classification'] && cc.facets['classification'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='classification' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>                  
                    <div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['objectname'] && cc.facets['objectname'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_objectname")}</span>
                        {cc.facets['objectname'] && cc.facets['objectname'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='objectname' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    <div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['creator'] && cc.facets['creator'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_creator")}</span>
                        {cc.facets['creator'] && cc.facets['creator'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='creator' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    {true && <>
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.hierarchicalFacets['theme'] && cc.hierarchicalFacets['theme'].length > 0 ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_theme")}</span>
                          {cc.hierarchicalFacets['theme'] && cc.hierarchicalFacets['theme'].length > 0 ?
                            <span className={styles.facetActiveDot}></span> : null}
                        </div>
                        <div className={styles.facet}>
                          <HierarchicalFacet hierarchicalFacetName='theme' topCN='MVW.AAJ' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                        </div>
                      </div>
                    </>
                    }
                    {true && <>
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.hierarchicalFacets['place'] && cc.hierarchicalFacets['place'].length > 0 ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_place")}</span>
                          {cc.hierarchicalFacets['place'] && cc.hierarchicalFacets['place'].length > 0 ?
                            <span className={styles.facetActiveDot}></span> : null}
                        </div>
                        <div className={styles.facet}>
                          <HierarchicalFacet hierarchicalFacetName='place' topCN='MVW.AAL.AAC' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                        </div>
                      </div>
                    </>
                    }
                    <div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['recordtype'] && cc.facets['recordtype'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_recordtype")}</span>
                        {cc.facets['recordtype'] && cc.facets['recordtype'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='recordtype' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>

                    {(ccUtils.generateQuery(cc, user).indexOf('thème: Tapisseries') > 0 || ccUtils.generateQuery(cc, user).indexOf('theme: Tapisseries') > 0) && (<div className={styles.facetContainer}>
                      <div className={`${styles.facetName} ${cc.facets['collection'] && cc.facets['collection'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_collection")}</span>
                        {cc.facets['collection'] && cc.facets['collection'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='collection' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    )}

                    {user && (  // Only show if user is logged in
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.customSearchCriteria.some(c => c.fieldLabel === t('basket_items')) ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_baskets")}</span>
                          {cc.customSearchCriteria.some(c => c.fieldLabel === t('basket_items')) &&
                            <span className={styles.facetActiveDot}></span>
                          }
                        </div>
                        <div className={styles.facet}>
                          <BasketFacet contentHeight='160px' sort='alpha' />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {viewMode !== 'homepage' ? (
                  <div className={styles.homePageButton}>
                    <GenericIconButton
                      icon='light/house.svg'
                      hoverEnabled={true}
                      width='28px'
                      height='28px'
                      onClick={(e: any) => {
                        e.preventDefault();
                        //const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false };
                        //const newStateCc = ccUtils.convertStateToCC(newState);
                        //setCc(newStateCc);
                        setViewMode('homepage');
                      }}
                    />
                  </div>
                ) : (null)
                }
                <div className={styles.rightColumn}>
                  <div className={styles.searchContainer}>
                    <div className={styles.simpleSearchBox}>
                      <SimpleSearchBox Fields="simple" id="simpleSearch" showSearchButton={true} />
                    </div>
                  </div>

                  {viewMode !== 'homepage' ?
                    <div>
                      {viewMode !== "map" &&
                        <div className={styles.displayControl}>
                          <ViewMode />
                          <div className={styles.displayControlSeperator} />
                          <div className={styles.displayControlItem}>
                            <BrowseMode />
                          </div>
                          {browseMode !== 'scroll' &&
                            (<>
                              <div className={styles.displayControlSeperator} />
                              <div className={styles.displayControlItem}>
                                <Navigator />
                              </div>
                            </>
                            )
                          }
                          <Sort />
                        </div>
                      }
                      {viewMode == "map" && (<div style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <ViewMode />
                        <div className={styles.hyperlinkBackToCollection} style={{ "display": "none" }} onClick={(e) => { setViewMode('list') }}>{t("map_return_to_list")}</div>
                      </div>
                      )
                      }
                      <QuerySummary />

                      {viewMode == "map" && (
                        <div className={styles.map}>
                          <Map dzi="https://collections.quaibranly.fr/pod23/cc/imageproxy.ashx?server=localhost&port=15012&filename=images/MQB_CC3V2_02_21031210_PH.dzi" />
                        </div>
                      )
                      }

                      {
                        viewMode !== "map" ? (
                          <>
                            <ResultSet />
                            {browseMode !== 'scroll' && (
                              <div className={styles.navigatorBottom}>
                                <div className={styles.displayControlSeperator} />
                                <div className={styles.displayControlItem}>
                                  <Navigator />
                                </div>
                              </div>
                            )}
                          </>
                        ) : null
                      }

                    </div>
                    :
                    <div>
                      <div className={styles.intro}>
                        <div className={styles.introText}>
                          {imageUrl && <AnnotatedImageViewer imageName={imageUrl} annotationSource={""} />}
                          {i18n.language === 'en' ? <div className={styles.introTextText} dangerouslySetInnerHTML={{ __html: introTextEnglish }} /> : i18n.language === 'fr' ? <div className={styles.introTextText} dangerouslySetInnerHTML={{ __html: introTextFrench }} /> : ''}
                        </div>
                        {/*<div className={styles.introHyperlink} onClick={(e) => { setViewMode('list') }}>{t("homepage_click_to_view")}</div>*/}
                      </div>
                      {true && (
                        <div>
                          {showAlbumEmbed && <AlbumViewer initialAlbumId={showAlbumEmbed} />}
                          {!showAlbumEmbed && <AlbumViewer initialAlbumId="04493ee5-01a7-4bc0-b286-2ebbc4f22cb5" />}
                        </div>
                      )}
                      {/*
                        <div className={styles.homepageBlocks}>
                          <HomepageBlock
                            onClick={(e) => {
                              e.preventDefault();
                              ccUtils.clearFacet(ctx, 'department');
                              if (i18n.language === 'fr') {
                                ccUtils.addCustomSearch(ctx, '/record/theme', 'Thème', ['[thème: Tapisseries]'], '');
                              } else {
                                ccUtils.addCustomSearch(ctx, '/record/themeeng', 'Theme', ['[theme: Tapisseries]'], '');
                              }

                              setViewMode('list');
                            }}

                            imageUrl={"https://collections.monuments-nationaux.fr/ccImageProxy.ashx?filename=images/033/images%20pleine%20page/CMN_dbw16_0865.jpg&width=350&_height=220&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=f8f8f8&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes"}
                            text={t("homepageblock_tapisseries")}
                          />
                        </div>
                      */}  
                    </div>

                  }
                </div>
              </div>
            </div>
          </div>
          {debugOpen && <DebugCC onClose={handleDebugClose} />}
          {
            showScrollToTop &&
            <div className={styles.scrollToTop} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <GenericIconButton icon='regular/chevron-up.svg' width='24px' height='24px' />
            </div>
          }
          <Footer />
        </div>
      )}
    </I18nextProvider>
  );
}

function App() {
  useEffect(() => {
    console.log('initialize app');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${process.env.REACT_APP_USERMANAGEMENT_URL}?action=downloadCustomCss&filename=${"inlineStyles.css"}`;
    link.type = 'text/css';
    document.head.appendChild(link);

    const link2 = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = `${process.env.REACT_APP_USERMANAGEMENT_URL}?action=downloadCustomCss&filename=${"paragraphStyles.css"}`;
    link2.type = 'text/css';
    document.head.appendChild(link2);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(link2);
    };
  }, []);

  return (
    <Router>
      <CCProvider>
        <MainContent />
      </CCProvider>
    </Router>
  );
}

export default App;
